import * as analytics from 'analytics-core';
import { BlockComponentProps as Props } from 'client-react-block-renderer';
import React, { Component } from 'react';

import CookieNoticeSettings from './CookieNoticeSettings';

interface State { }

export default class CookieNoticeSettingsBlock extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.handleValueChange = this.handleValueChange.bind(this);
    }

    public handleValueChange(value: boolean) {
        analytics.setAllowAnalytics(value);
        this.forceUpdate();
    }

    public render() {
        return <CookieNoticeSettings
            onValueChange={this.handleValueChange}
            allowAnalytics={analytics.getAllowAnalytics()} />;
    }
}
